import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../commons/shared.module';
import { AppRoutes } from '../../commons/global';
import { SettingsComponent } from './settings.component';
import { IntegrationsComponent } from './integrations.component';
import { UsersComponent } from './users.component';
import { BillingComponent } from './billing.component';
import { BillingDialogComponent } from './billing-dialog.component';
import { AddUserDialog } from './user-add.dialog';
import {ShareProjectDialog} from './share-project/share-project-dialog.component';
import {PhotogramEstimatePriceDialog} from './photogram-estimate-price/photogram-estimate-price-dialog.component';
import { UsersDetails } from './user_details.component';
import { QMAPModule } from 'ng-qmap';

const AppRouting: Routes = [

    { path: '', redirectTo:AppRoutes.ACCOUNT, pathMatch: 'full'},
    { path: AppRoutes.ACCOUNT, component:SettingsComponent, pathMatch: 'full' },
    { path: 'plan', component:BillingComponent, pathMatch: 'full' },
    { path: AppRoutes.APIS, component:IntegrationsComponent, pathMatch: 'full' },
    { path: AppRoutes.USERS, component:UsersComponent, pathMatch: 'full' }
];

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        QMAPModule,
        SharedModule,
        RouterModule.forChild(AppRouting)
    ],
    entryComponents:[AddUserDialog, ShareProjectDialog,BillingDialogComponent, PhotogramEstimatePriceDialog],
    declarations: [
        SettingsComponent,
        IntegrationsComponent,
        UsersComponent,
        AddUserDialog,
        BillingComponent,
        BillingDialogComponent, PhotogramEstimatePriceDialog,
      ShareProjectDialog,UsersDetails
    ],
})

export class SettingsModule {


}
